import { END_SESSION } from '../actions/authActions';
import { UNSUBSCRIBE_CURRENT_ACCOUNT } from '../actions/currentAccountActions';
import { SET_NOTE_PHOTOS } from '../actions/notePhotoActions';

const DEFAULT_STATE = { items: {} };

export default function notePhotosReducer(state = DEFAULT_STATE, { type, payload }) {
  switch (type) {
    case END_SESSION:
    case UNSUBSCRIBE_CURRENT_ACCOUNT:
      return DEFAULT_STATE;
    case SET_NOTE_PHOTOS:
      return { ...state, items: { ...state.items, [payload.id]: payload.items } };
    default:
      return state;
  }
}

export const getNotePhotos = (state, noteId) => {
  return state.items[noteId] || [];
};
